export abstract class AssignationRoutes {
    static Self = 'self';
    static List = 'list';
    static Closed = 'closed';
    static UserSaves = 'results';
    static GroupsList = 'groups';
    static GroupsListDetail = 'groupsdetail';
    static LogBook = 'logbook';
}